import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { NewStyleColor } from '../../../../../utils/styles-constants';
import { hexToRgba } from '../../../../../utils/style';
import { DEFAULT_SCALE } from '../../../Spread/Background';

interface MediaInnerProps {
	isActive: boolean;
	isPhone: boolean;
}

interface ImageProps {
	url: string;
	top: number;
	left: number;
	scale: number;
}

interface RangeSliderWrapperProps {
	hasTooltip?: boolean;
}

interface LabelProps {
	isActive: boolean;
}

const Wrapper = styled('div')`
	margin-bottom: 15px;
`;

const MediaWrapper = styled('div')`
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	margin-bottom: 16px;
	padding: 16px;
	border-radius: 8px;
	background-color: ${hexToRgba(NewStyleColor.White, 10)};
`;

const MediaWrapperColumn = styled('div')`
	&:last-child {
		text-align: right;
	}
`;

const MediaInner = styled('div')`
	box-sizing: border-box;
	position: relative;
	width: ${({ isPhone }: MediaInnerProps) => isPhone ? '70px' : '230px'};
	height: 148px;
	border: 2px solid ${({ isActive }: MediaInnerProps) => isActive ? NewStyleColor.Blue450 : hexToRgba(NewStyleColor.White, 10)};
	border-radius: 8px;
	background-color: ${NewStyleColor.Grey900};
	overflow: hidden;
`;

const Image = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: ${({ url }: ImageProps) => `url(${url}) no-repeat`};
	background-size: cover;
	background-position: ${({ left, top }: ImageProps) => `${left}% ${top}%`};

	${({ scale }: ImageProps) => scale !== DEFAULT_SCALE && `
		transform: scale(${scale});
	`}
`;

const RangeSliderWrapper = styled('div')`
	box-sizing: border-box;
	position: relative;
	padding: 16px;
	border-radius: 8px;
	background-color: ${hexToRgba(NewStyleColor.White, 10)};

	${({ hasTooltip }: RangeSliderWrapperProps) => hasTooltip && 'padding-top: 30px;'}

	&:not(:last-of-type) {
		margin-bottom: 10px;
	}
`;

const Label = styled(Translate)`
	display: block;
	margin-bottom: 10px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 17px;
	line-height: 20px;
	color: ${({ isActive }: LabelProps) => isActive ? NewStyleColor.Blue450 : hexToRgba(NewStyleColor.White, 75)};
`;

export {
	Wrapper,
	MediaWrapper,
	MediaWrapperColumn,
	MediaInner,
	Image,
	RangeSliderWrapper,
	Label,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SpreadBackgroundPanel/MediaPreview/styles.ts